import React from 'react';
import { Grid, Box } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import AreaList from './AreaList';

// components



const Area = () => {
  return (
    <PageContainer title="Camp" description="this is Camp List">
      <Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <AreaList />
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Area;
